import type { PartSvgProps } from './types'

export default function BipodSvg ({
  fill = 'var(--gs-part-fill,   #2A2A3A)',
  stroke = 'var(--gs-part-stroke, #5A6A7A)',
  accent = 'var(--gs-part-accent, #E85D04)',
  width = 100,
  height = 120
}: PartSvgProps) {
  return (
    <svg viewBox="0 0 100 120" width={width} height={height} fill="none"
         xmlns="http://www.w3.org/2000/svg">
      {/* Mounting stud / yoke (top) */}
      <rect x="36" y="8" width="28" height="18" rx="4"
            fill={fill} stroke={accent} strokeWidth="1.5" />
      {/* Clamp bolt */}
      <circle cx="50" cy="17" r="5" fill="none" stroke={stroke} strokeWidth="1" />
      {/* Central pivot body */}
      <rect x="42" y="26" width="16" height="20" rx="3"
            fill={fill} stroke={stroke} strokeWidth="1.2" />
      {/* Left leg */}
      <path d="M 46 46 L 16 98 L 22 104 L 34 100 L 50 56 Z"
            fill={fill} stroke={stroke} strokeWidth="1.5" />
      {/* Right leg */}
      <path d="M 54 46 L 84 98 L 78 104 L 66 100 L 50 56 Z"
            fill={fill} stroke={stroke} strokeWidth="1.5" />
      {/* Left foot */}
      <ellipse cx="19" cy="106" rx="8" ry="4"
               fill={fill} stroke={accent} strokeWidth="1.2" />
      {/* Right foot */}
      <ellipse cx="81" cy="106" rx="8" ry="4"
               fill={fill} stroke={accent} strokeWidth="1.2" />
    </svg>
  )
}
